const normalizeMktu = (value) => {
  if (!value) return value;
  const normalizeOne = (v) => {
    const trimmed = String(v).trim();
    const num = parseInt(trimmed, 10);
    if (Number.isNaN(num)) return trimmed;
    return num.toString(); // возвращаем строку без ведущих нулей
  };
  return Array.isArray(value) ? value.map(normalizeOne) : normalizeOne(value);
};

export default normalizeMktu;
